import { useState } from 'react'
import { ITEMS_TO_FETCH } from '@mprolab/sdk'

export const useInfiniteScrollData = (
  initialDataLength?: number
): {
  dataLengthToFetch: number
  loadMoreData: () => NodeJS.Timeout
  loadMoreDataPromise: (timeout?: number) => Promise<number>
} => {
  const dataFetchAmount: number = initialDataLength || ITEMS_TO_FETCH
  const [dataLengthToFetch, setDataLengthToFetch] = useState<number>(dataFetchAmount)

  const loadMoreData = (): NodeJS.Timeout =>
    setTimeout(() => {
      setDataLengthToFetch(dataLengthToFetch + dataFetchAmount)
    }, 1000)

  const loadMoreDataPromise = (timeout = 1000): Promise<number> =>
    new Promise((resolve) => {
      setTimeout(() => {
        const newDataLength = dataLengthToFetch + dataFetchAmount
        setDataLengthToFetch(newDataLength)
        resolve(newDataLength)
      }, timeout)
    })

  return { dataLengthToFetch, loadMoreData, loadMoreDataPromise }
}
